"use strict";
// eslint-disable-next-line no-unused-vars
const axios = require('axios');
let numberOf401Errors = 0;
/* eslint-disable no-bitwise */
const generateUUID = (short) => {
    const mask = short ? 'xxxxxxxx-xxxx' : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return mask.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-mixed-operators
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
const addInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.response.use((response) => response, (error) => {
        if (numberOf401Errors > 4) {
            window.location.reload();
        }
        else if (error?.response?.status === 401) {
            numberOf401Errors += 1;
        }
        return Promise.reject(error);
    });
    axiosInstance.interceptors.request.use((config) => {
        // eslint-disable-next-line no-param-reassign
        config.headers['original-app-route'] = window?.location?.hash;
        // eslint-disable-next-line no-param-reassign
        config.headers.trace_id = generateUUID();
        return config;
    }, (error) => Promise.reject(error));
};
const create = (configuration) => {
    const instance = axios.create(configuration);
    addInterceptors(instance);
    return instance;
};
const instance = () => {
    const axiosInstance = axios;
    addInterceptors(axiosInstance);
    return axiosInstance;
};
const httpClient = {
    instance: instance(),
    create,
};
module.exports = {
    httpClient,
    generateUUID,
};
//# sourceMappingURL=index.js.map